import React, { useEffect, useState } from 'react';
import { MIcon } from '../../../lib/micon';
import { LdSheet } from '../../../components/ui/LdSheet';
import { LdSheetHeader, LdSheetSaveBar } from '../../../components/ld/LdForm';
import { datum } from './format';
import { LdDatum } from '../../../components/ld/LdFenster';

/** Welle P1c: Attestpflicht als Statuszeile im Fehlzeiten-Tab; Bearbeiten im Sheet */
export function AttestpflichtZeile({ aktiv, seit, notiz, onBearbeiten }: { aktiv: boolean; seit: string | null; notiz: string | null; onBearbeiten: () => void }) {
  return (
    <div className={`ld-ap${aktiv ? ' ld-ap--aktiv' : ''}`}>
      <MIcon name="assignment_late" size={20} />
      <div className="ld-ap__text">
        <b>Attestpflicht: {aktiv ? (seit ? `aktiv seit ${datum(seit.slice(0, 10))}` : 'aktiv') : 'nicht aktiv'}</b>
        {aktiv && notiz && <span>Grund: {notiz}</span>}
        {!aktiv && <span>Fehlzeiten brauchen kein Attest.</span>}
      </div>
      <button type="button" className="ld-pk-aktion" onClick={onBearbeiten}><MIcon name="edit" size={16} />Bearbeiten</button>
    </div>
  );
}

export function AttestpflichtSheet({ open, schuelerName, aktiv, seit, notiz, onClose, onSpeichern }: {
  open: boolean; schuelerName: string; aktiv: boolean; seit: string; notiz: string;
  onClose: () => void; onSpeichern: (aktiv: boolean, seit: string, notiz: string) => Promise<boolean>;
}) {
  const [a, setA] = useState(aktiv);
  const [s, setS] = useState(seit);
  const [n, setN] = useState(notiz);
  const [laeuft, setLaeuft] = useState(false);
  useEffect(() => { if (open) { setA(aktiv); setS(seit?.slice(0, 10) ?? ''); setN(notiz ?? ''); } }, [open, aktiv, seit, notiz]);
  async function speichern() {
    setLaeuft(true);
    const ok = await onSpeichern(a, a ? s : '', a ? n : '');
    setLaeuft(false);
    if (ok) onClose();
  }
  return (
    <LdSheet open={open} onClose={onClose} maxWidth={480} ariaLabel="Attestpflicht bearbeiten">
      <div className="ld-mws">
        <LdSheetHeader icon={<MIcon name="assignment_late" size={20} />} title="Attestpflicht" subtitle={schuelerName} onClose={onClose} />
        <div className="ld-gs__schalter">
          <MIcon name="medical_information" size={20} />
          <div><b>{a ? 'Aktiv' : 'Nicht aktiv'}</b><small>Ab diesem Tag braucht jede Fehlzeit ein Attest</small></div>
          <button type="button" role="switch" aria-checked={a} aria-label="Attestpflicht aktiv" className={`ld-gs__switch${a ? ' an' : ''}`} onClick={() => setA(x => !x)}><span /></button>
        </div>
        {a && (
          <>
            <label className="ld-gs__feld"><span>Aktiv seit (optional)</span>
              <LdDatum value={s} onChange={e => setS(e.target.value)} /></label>
            <label className="ld-gs__feld"><span>Grund (optional)</span>
              <input value={n} onChange={e => setN(e.target.value)} placeholder="z. B. Anordnung der Schulleitung vom 14.03." /></label>
          </>
        )}
        <LdSheetSaveBar onClick={speichern} loading={laeuft}>Speichern</LdSheetSaveBar>
      </div>
    </LdSheet>
  );
}
